<template>
  <div style="background-color: #f5f6f8; padding: 20px; min-height: 100vh; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
    <!-- Header Section -->
    <div style="background-color: #ffffff; border-radius: 4px; padding: 12px 20px; margin-bottom: 20px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); border: 1px solid #e5e7eb; display: flex; justify-content: space-between; align-items: center;">
      <div style="display: flex; align-items: center; gap: 10px;">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="#555">
          <path d="M4 4h5v5H4V4zm7 0h5v5h-5V4zm7 0h5v5h-5V4zM4 11h5v5H4v-5zm7 0h5v5h-5v-5zm7 0h5v5h-5v-5zM4 18h5v5H4v-5zm7 0h5v5h-5v-5zm7 0h5v5h-5v-5z"/>
        </svg>
        <span style="font-weight: 700; font-size: 15px; color: #444; letter-spacing: 0.5px; text-transform: uppercase;">View-Reject-Payment-Reversals</span>
      </div>
      <button @click="goBack" style="background: #800080; border: 1px solid #d1d5db; border-radius: 4px; padding: 6px 14px; color: #ffffff; font-weight: 600; font-size: 12px; cursor: pointer; display: flex; align-items: center; gap: 6px; box-shadow: 0 1px 2px rgba(0,0,0,0.02);">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
        </svg>
        Close
      </button>
    </div>

    <!-- Main Content -->
    <div style="background-color: #ffffff; border-radius: 4px; padding: 24px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); border: 1px solid #e5e7eb;">
      <!-- Header with Avatar and Receipt Info -->
      <div style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap;">
        <div style="display: flex; gap: 24px; flex-wrap: wrap; align-items: flex-start;">
          <!-- Avatar -->
          <div v-if="!userImage" style="width: 72px; height: 72px; border-radius: 50%; background-color: #ffffff; border: 1px solid #d1d5db; display: flex; align-items: center; justify-content: center;">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="#9ca3af">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
          </div>
          <div v-else style="width: 72px; height: 72px; border-radius: 50%; overflow: hidden; border: 1px solid #d1d5db;">
            <img :src="imageSrc" style="width: 100%; height: 100%; object-fit: cover;" alt="User avatar">
          </div>

          <!-- Receipt Info -->
          <div style="display: flex; flex-direction: column; gap: 8px; padding-top: 4px;">
            <div style="font-size: 14px; color: #6b7280; font-weight: 600;">
              Receipt ID: <span style="font-weight: 400; color: #111827; margin-left: 4px;">{{ receiptData.receipt_id || 'N/A' }}</span>
            </div>
            <div style="font-size: 14px; color: #6b7280; font-weight: 600;">
              Payment Method: <span style="font-weight: 400; color: #111827; margin-left: 4px;">{{ receiptData.payment_method || 'N/A' }}</span>
            </div>
            <div style="display: flex; gap: 10px; flex-wrap: wrap; margin-top: 4px;">
              <span :style="{
                backgroundColor: receiptData.payment_status === 'Paid' ? '#f0fdf4' : '#fef3c7',
                color: receiptData.payment_status === 'Paid' ? '#166534' : '#92400e',
                padding: '4px 12px',
                borderRadius: '9999px',
                fontSize: '11px',
                fontWeight: '600',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                border: receiptData.payment_status === 'Paid' ? '1px solid #86efac' : '1px solid #fcd34d'
              }">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
                PAYMENT STATUS - {{ receiptData.payment_status || 'N/A' }}
              </span>
              <span :style="{
                backgroundColor: receiptData.receipt_status === 'Full_Payment' ? '#f0fdf4' : '#fef3c7',
                color: receiptData.receipt_status === 'Full_Payment' ? '#166534' : '#92400e',
                padding: '4px 12px',
                borderRadius: '9999px',
                fontSize: '11px',
                fontWeight: '600',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                border: receiptData.receipt_status === 'Full_Payment' ? '1px solid #86efac' : '1px solid #fcd34d'
              }">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
                RECEIPT STATUS - {{ receiptData.receipt_status || 'N/A' }}
              </span>
            </div>
          </div>
        </div>

        <!-- Delete Button -->
        <button v-if="permissions.delete" @click="confirmDelete" style="background: #ffffff; border: 1px solid #fca5a5; border-radius: 4px; padding: 8px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #dc2626; transition: all 0.2s;">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
          </svg>
        </button>
      </div>

      <!-- Overdue Information -->
      <div v-if="receiptData.overdue_reason && receiptData.overdue_reason !== '-'" style="margin-top: 20px; padding: 16px; background-color: #fef3c7; border-radius: 4px; border: 1px solid #fcd34d;">
        <div style="font-size: 12px; color: #92400e; margin-bottom: 8px; font-weight: 600;">Overdue Information</div>
        <div style="font-size: 13px; color: #78350f;">Reason: {{ receiptData.overdue_reason }}</div>
        <div style="font-size: 13px; color: #78350f; margin-top: 4px;">Approval Status: {{ receiptData.overdue_approval_status }}</div>
      </div>

      <hr style="margin: 24px 0; border: none; border-top: 1px solid #f3f4f6;">

      <!-- Receipt Summary Section -->
      <div style="margin-bottom: 32px; background-color: #f9fafb; padding: 20px; border-radius: 4px; border: 1px solid #e5e7eb;">
        <div style="font-weight: 700; font-size: 14px; color: #374151; margin-bottom: 16px;">RECEIPT SUMMARY</div>
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 20px;">
          <div>
            <div style="font-size: 12px; color: #6b7280; margin-bottom: 4px;">Total Amount</div>
            <div style="font-size: 18px; font-weight: 700; color: #111827;">LKR {{ formatNumber(receiptData.collect_total_amount) }}</div>
          </div>
          <div>
            <div style="font-size: 12px; color: #6b7280; margin-bottom: 4px;">Created Date</div>
            <div style="font-size: 14px; color: #374151;">{{ formatDate(receiptData.created_at) }}</div>
          </div>
          <div>
            <div style="font-size: 12px; color: #6b7280; margin-bottom: 4px;">Last Updated</div>
            <div style="font-size: 14px; color: #374151;">{{ formatDate(receiptData.updated_at) }}</div>
          </div>
        </div>
      </div>

      <!-- Dealer Information Section -->
      <div style="display: flex; gap: 32px; flex-wrap: wrap; margin-bottom: 32px;">
        <div style="flex: 1; min-width: 300px;">
          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Dealer Name</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">{{ currentItem.name || 'N/A' }}</div>
          </div>
          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Dealer No</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">{{ currentItem.customer_no || 'N/A' }}</div>
          </div>
        </div>
      </div>

      <!-- Payment Method Details Section -->
      <div v-if="receiptData.payment_method === 'Bank'" style="margin-bottom: 32px; border: 1px solid #d1d5db; border-radius: 4px; padding: 14px; background-color: #f9fafb;">
        <div style="display: flex; align-items: center; gap: 14px;">
          <div style="width: 36px; height: 36px; background-color: #800080; border-radius: 4px; display: flex; align-items: center; justify-content: center;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="#ffffff">
              <path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"/>
            </svg>
          </div>
          <div style="flex: 1;">
            <div style="font-weight: 600; font-size: 13px; color: #374151;">Bank Information</div>
            <div style="font-size: 12px; color: #6b7280; margin-top: 2px;">{{ receiptData.bank_name || 'No bank details available' }}</div>
            <div style="font-size: 12px; color: #6b7280; margin-top: 2px;">Branch: {{ receiptData.branch_name || 'N/A' }}</div>
          </div>
        </div>
      </div>

      <div v-if="receiptData.payment_method === 'Cheque'" style="margin-bottom: 32px; border: 1px solid #d1d5db; border-radius: 4px; padding: 14px; background-color: #f9fafb;">
        <div style="display: flex; align-items: center; gap: 14px;">
          <div style="width: 36px; height: 36px; background-color: #800080; border-radius: 4px; display: flex; align-items: center; justify-content: center;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="#ffffff">
              <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
            </svg>
          </div>
          <div style="flex: 1;">
            <div style="font-weight: 600; font-size: 13px; color: #374151;">Cheque Information</div>
            <div style="font-size: 12px; color: #6b7280; margin-top: 2px;">Cheque No: {{ receiptData.cheque_number || 'N/A' }}</div>
            <div style="font-size: 12px; color: #6b7280; margin-top: 2px;">Cheque Date: {{ formatDate(receiptData.cheque_date) }}</div>
            <div style="font-size: 12px; color: #6b7280; margin-top: 2px;">Cheque Amount: LKR {{ formatNumber(receiptData.cheque_amount) }}</div>
            <div style="font-size: 12px; color: #6b7280; margin-top: 2px;">Bank: {{ receiptData.bank_name || 'N/A' }}</div>
          </div>
        </div>
      </div>

      <!-- Data Table Section -->
      <div style="margin-top: 32px;">
        <div style="margin-bottom: 16px;">
          <div style="font-weight: 700; font-size: 14px; color: #374151; margin-bottom: 12px;">RECEIPT ITEMS</div>
          <v-text-field
            v-model="search"
            label="Search"
            prepend-inner-icon="mdi-magnify"
            dense
            outlined
            hide-details
            style="max-width: 300px;"
          />
        </div>
        <v-data-table
          :headers="headers"
          :items="filteredItems"
          :items-per-page="itemsPerPage"
          :search="search"
          density="comfortable"
          class="custom_table_normal"
          hide-default-footer
        >
          <template v-slot:[`item.data-table-select`]="{ item }">
            <v-switch
              inset
              hide-details
              color="purple"
              v-model="item.selected"
              @change="updateSelectedLeads"
            />
          </template>

          <template v-slot:[`item.dealer`]="{ item }">
            <div class="dealer-cell">
              <div class="dealer-name">{{ item.name || item.dealer }}</div>
              <div class="reg-number">
                Reg num: <span>{{ item.regNumber || item.customer_no }}</span>
              </div>
            </div>
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <div class="action-wrapper">
              <span class="remove-text">REMOVE</span>
              <v-switch
                inset
                hide-details
                color="purple"
                v-model="item.active"
              />
              <span class="add-text">ADD</span>
            </div>
          </template>

          <template v-slot:[`item.amount`]="{ item }">
            <span>LKR {{ formatNumber(item.amount) }}</span>
          </template>

          <template v-slot:[`item.remaining_amount`]="{ item }">
            <span>LKR {{ formatNumber(item.remaining_amount) }}</span>
          </template>

          <template v-slot:[`item.assigned_amount`]="{ item }">
            <span>LKR {{ formatNumber(item.assigned_amount) }}</span>
          </template>

          <template v-slot:[`item.actual_remaining_amount`]="{ item }">
            <span>LKR {{ formatNumber(item.actual_remaining_amount) }}</span>
          </template>

          <template v-slot:[`item.change_amount`]="{ item }">
            <span>LKR {{ formatNumber(item.change_amount) }}</span>
          </template>

          <template v-slot:[`item.change_remaining_amount`]="{ item }">
            <span>LKR {{ formatNumber(item.change_remaining_amount) }}</span>
          </template>

          <template v-slot:[`item.change_assigned_amount`]="{ item }">
            <span>LKR {{ formatNumber(item.change_assigned_amount) }}</span>
          </template>

          <template v-slot:[`item.change_actual_remaining_amount`]="{ item }">
            <span>LKR {{ formatNumber(item.change_actual_remaining_amount) }}</span>
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <span :style="{
              color: item.status === 'Paid' ? '#10b981' : '#f59e0b',
              fontWeight: '600'
            }">
              {{ item.status || 'N/A' }}
            </span>
          </template>
        </v-data-table>
      </div>

      <!-- Images Section -->
      <div v-if="receiptData.image1 || receiptData.image2" style="margin-top: 32px; padding-top: 24px; border-top: 1px solid #e5e7eb;">
        <div style="font-weight: 700; font-size: 14px; color: #374151; margin-bottom: 16px;">ATTACHMENTS</div>
        <div style="display: flex; gap: 20px; flex-wrap: wrap;">
          <div v-if="receiptData.image1" style="flex: 1; min-width: 200px;">
            <label style="display: block; font-size: 12px; color: #6b7280; margin-bottom: 8px;">Image 1</label>
            <img :src="getImageUrl(receiptData.image1)" style="max-width: 100%; max-height: 200px; border-radius: 4px; border: 1px solid #e5e7eb;" alt="Receipt Image 1">
          </div>
          <div v-if="receiptData.image2" style="flex: 1; min-width: 200px;">
            <label style="display: block; font-size: 12px; color: #6b7280; margin-bottom: 8px;">Image 2</label>
            <img :src="getImageUrl(receiptData.image2)" style="max-width: 100%; max-height: 200px; border-radius: 4px; border: 1px solid #e5e7eb;" alt="Receipt Image 2">
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Confirmation Dialog -->
    <div v-if="deleteDialog" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000;">
      <div style="background-color: white; border-radius: 4px; width: 400px; max-width: 90%; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
        <div style="padding: 16px; background-color: #f9fafb; border-top-left-radius: 4px; border-top-right-radius: 4px; border-bottom: 1px solid #e5e7eb; display: flex; align-items: center; justify-content: space-between;">
          <span style="font-weight: 700; font-size: 14px; color: #374151;">DELETE COLLECTION DATA</span>
          <button @click="deleteDialog = false" style="background: none; border: none; cursor: pointer; font-size: 20px; color: #6b7280;">&times;</button>
        </div>
        <div style="padding: 24px;">
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 15px;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#f59e0b">
              <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
            </svg>
            <span style="font-weight: 600; color: #dc2626; font-size: 15px;">Do you want to delete this collection record?</span>
          </div>
          <p style="font-size: 13px; color: #4b5563; margin-bottom: 24px; line-height: 1.5;">This collection record will be deleted immediately. Once deleted, it can no longer be used for any purpose.</p>
          <hr style="margin: 16px 0; border: none; border-top: 1px solid #e5e7eb;">
          <div style="display: flex; justify-content: flex-end; gap: 12px; margin-top: 20px;">
            <button @click="deleteDialog = false" style="padding: 8px 16px; background: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; font-size: 13px; font-weight: 600; color: #4b5563; cursor: pointer;">CANCEL</button>
            <button @click="deleteItem" style="padding: 8px 16px; background-color: #dc2626; color: white; border: none; border-radius: 4px; font-size: 13px; font-weight: 600; cursor: pointer;">DELETE</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { EventBus } from "@/plugins/event-bus";
import { getPermissions } from "@/plugins/permissions";

export default {
  name: "Total_Collections_View",
  data() {
    return {
      activeTab: 'cash',
      deleteDialog: false,
      search: '',
      itemsPerPage: 10,
      
      receiptId: null,
      userId: null,
      selectedItemIndex: 0,
      
      agentName: 'Loading...',
      mobileNumber: 'Loading...',
      userType: 'SALES REP',
      userImage: null,
      
      receiptData: {
        id: null,
        receipt_id: null,
        payment_method: null,
        payment_status: null,
        collect_total_amount: null,
        receipt_status: null,
        cheque_number: null,
        cheque_amount: null,
        cheque_date: null,
        bank_name: null,
        branch_name: null,
        overdue_reason: null,
        overdue_approval_status: null,
        image1: null,
        image2: null,
        created_at: null,
        updated_at: null,
        items: []
      },
      
      permissions: {},
      
      headers: [
        { title: 'DEALER', key: 'dealer', sortable: true },
        { title: 'DOCUMENT TYPE', key: 'document_type', sortable: true },
        { title: 'DOCUMENT NO', key: 'document_no', sortable: true },
        { title: 'POSTING DATE', key: 'posting_date', sortable: true },
        { title: 'AMOUNT (LKR)', key: 'amount', sortable: true },
        { title: 'REMAINING (LKR)', key: 'remaining_amount', sortable: true },
        { title: 'ASSIGNED (LKR)', key: 'assigned_amount', sortable: true },
        { title: 'ACTUAL REMAINING', key: 'actual_remaining_amount', sortable: true },
        { title: 'CHANGE AMOUNT', key: 'change_amount', sortable: true },
        { title: 'CHANGE REMAINING', key: 'change_remaining_amount', sortable: true },
        { title: 'CHANGE ASSIGNED', key: 'change_assigned_amount', sortable: true },
        { title: 'CHANGE ACTUAL REMAINING', key: 'change_actual_remaining_amount', sortable: true },
        { title: 'STATUS', key: 'status', sortable: true },
      ],
    };
  },

  computed: {
    imageSrc() {
      if (this.userImage) {
        return `${process.env.VUE_APP_API_BASE_URL}/SFA/public/${this.userImage}`;
      }
      return '';
    },
    
    currentItem() {
      if (this.receiptData.items && this.receiptData.items.length > 0) {
        return this.receiptData.items[this.selectedItemIndex] || {};
      }
      return {};
    },

    filteredItems() {
      if (!this.receiptData.items || !this.receiptData.items.length) return [];
      
      if (!this.search) return this.receiptData.items;
      
      const searchLower = this.search.toLowerCase();
      return this.receiptData.items.filter(item => {
        return (
          (item.name && item.name.toLowerCase().includes(searchLower)) ||
          (item.dealer && item.dealer.toLowerCase().includes(searchLower)) ||
          (item.document_no && item.document_no.toLowerCase().includes(searchLower)) ||
          (item.customer_no && item.customer_no.toLowerCase().includes(searchLower))
        );
      });
    }
  },

  methods: {
    formatNumber(value) {
      if (!value && value !== 0) return '0.00';
      const num = parseFloat(value);
      if (isNaN(num)) return '0.00';
      return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },

    getImageUrl(imagePath) {
      if (!imagePath) return '';
      if (imagePath.startsWith('http')) return imagePath;
      return `${process.env.VUE_APP_API_BASE_URL}/SFA/public/${imagePath}`;
    },

    goBack() {
      // Use this.$router.go(-1) to go back to previous page
      this.$router.go(-1);
    },

    confirmDelete() {
      this.deleteDialog = true;
    },

    deleteItem() {
      const token = localStorage.getItem('token');
      const id = this.receiptId;

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/collections/delete/${id}`, { userId: this.userId }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(() => {
        this.deleteDialog = false;
        EventBus.emit('collectionsRecodeManagementButtonClick2');
        this.goBack();
      })
      .catch(error => {
        console.error("There was an error deleting the receipt!", error);
        alert('Failed to delete collection record');
      });
    },

    updateSelectedLeads() {
      console.log('Selected leads updated');
    },

    fetchReceiptData() {
      const token = localStorage.getItem('token');
      const id = this.receiptId;
      const userId = this.userId;

      if (!id) {
        console.error('No receipt ID provided');
        this.agentName = 'Error: No ID provided';
        return;
      }

      axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/receipt/${id}`, {
        params: { userId: userId },
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        console.log("Receipt API Response:", response.data);
        if (response.data.success && response.data.data) {
          this.receiptData = response.data.data;
          
          if (this.receiptData.items && this.receiptData.items.length > 0) {
            this.receiptData.items.forEach(item => {
              item.selected = item.selected || false;
              item.active = item.active || false;
              item.dealer = item.name;
            });
            
            const firstItem = this.receiptData.items[0];
            this.agentName = firstItem.name || 'N/A';
            this.mobileNumber = firstItem.customer_no || 'N/A';
            this.userType = firstItem.document_type === 'Invoice' ? 'INVOICE' : 'SALES REP';
          } else {
            this.agentName = 'N/A';
            this.mobileNumber = 'N/A';
          }
        } else {
          console.error('Invalid API response structure');
          this.agentName = 'Error: Invalid response';
        }
      })
      .catch(error => {
        console.error("Error fetching receipt data:", error);
        this.agentName = 'Error loading data';
        this.mobileNumber = 'Error loading data';
      });
    },
  },
  
  created() {
    this.receiptId = this.$route.params.id;
    this.userId = localStorage.getItem('userId');
    this.fetchReceiptData();
  },

  mounted() {
    const dashboardId = 6;
    this.permissions = getPermissions(dashboardId);
  },
};
</script>

<style scoped>
.custom_table_normal {
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.dealer-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dealer-name {
  font-weight: 600;
  color: #111827;
  font-size: 13px;
}

.reg-number {
  font-size: 11px;
  color: #6b7280;
}

.reg-number span {
  font-weight: 500;
  color: #374151;
}

.action-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.remove-text {
  font-size: 11px;
  font-weight: 600;
  color: #dc2626;
  cursor: pointer;
}

.add-text {
  font-size: 11px;
  font-weight: 600;
  color: #10b981;
  cursor: pointer;
}

.v-data-table {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.v-data-table th {
  background-color: #f9fafb !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  color: #374151 !important;
  border-bottom: 1px solid #e5e7eb !important;
}

.v-data-table td {
  font-size: 13px !important;
  color: #111827 !important;
  border-bottom: 1px solid #f3f4f6 !important;
}

.v-data-table tbody tr:hover {
  background-color: #f9fafb !important;
}
</style>